import { useNavigate } from "react-router-dom";
import { ContentsTopWrap } from "../../style/contents/common/common";
import SearchForm from "./search.form";
import { ReactNode } from "react";

interface Props {
  title?: string;
  titleSlot?: ReactNode; // ⭐ 추가
  onSearch?: (keyword: string) => void;
  onPageSizeChange?: (size: string) => void;
  pageSizeHidden?: boolean;
  className?: string;
  backArrowPath?: string;
}

const ContentsTopHeader = ({
  title,
  titleSlot,
  onSearch,
  onPageSizeChange,
  pageSizeHidden,
  className,
  backArrowPath,
}: Props) => {
  const navigate = useNavigate();
  const backArrowClicked = () => {
    if (backArrowPath === "-1") {
      navigate(-1);
    } else if (backArrowPath) {
      navigate(`${backArrowPath}`);
    }
  };
  return (
    <ContentsTopWrap className={className}>
      <div className="l">
        {backArrowPath && (
          <div className="back-arrow">
            <button onClick={backArrowClicked}>
              <img src="/assets/left-arrow.png" alt="" />
            </button>
          </div>
        )}
        {titleSlot ? (
          ""
        ) : (
          <div className="icon-box">
            <img src="/assets/cpu.png" alt="" />
          </div>
        )}
        <div className="title-area">
          {titleSlot ? titleSlot : <p>{title}</p>}
        </div>
      </div>
      {onSearch && onPageSizeChange && (
        <div className="r">
          <SearchForm
            onSearch={onSearch}
            onPageSizeChange={onPageSizeChange}
            pageSizeHidden={pageSizeHidden}
          />
        </div>
      )}
    </ContentsTopWrap>
  );
};

export default ContentsTopHeader;
